import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BACKEND_URL, ORGANIZATION_REQUEST_PREFIX } from '@data-terminal/data-access/injection-tokens';
import { DataTransferSettings } from '@data-terminal/shared-models/datatransfer';
import { catchError, EMPTY, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SettingsDataTransferApiService {
    private readonly http = inject(HttpClient);
    private readonly backendUrl = inject(BACKEND_URL);
    private readonly orgRequestPrefix = inject(ORGANIZATION_REQUEST_PREFIX);

    private readonly DATATRANSFER_URL = `${this.backendUrl}${this.orgRequestPrefix}settings`;

    public getDataTransferSettings(): Observable<DataTransferSettings> {
        return this.http.get<DataTransferSettings>(this.DATATRANSFER_URL);
    }

    public setDataTransferSettings(body: DataTransferSettings): Observable<DataTransferSettings> {
        const payload = {
            logs: body.logs,
            orderbag: body.orderbag,
            previews: body.previews,
            customerName: body.customerName,
            cloudAdminName: body.cloudAdminName,
        };
        return this.http.post<DataTransferSettings>(this.DATATRANSFER_URL, payload).pipe(catchError(() => EMPTY));
    }
}
